// Module
var code = "<button class=\"btn btn-default btn-sm\" title=\"{{'Download logs as zip file'|translate}}\" ng-click=\"vm.download()\"> <span class=\"fa fa-fw fa-download\"></span> </button>";
// Exports
module.exports = code;